import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/topo',
  name: 'topo',
  component: () => import('../views/topo.vue')
},{
  path: '/',
  name: 'index',
  component: () => import('../views/index.vue')
}]
const router = new VueRouter({
  mode: "history",
  routes
})

export default router